
<div>
  <table class="custom-table-list" aria-label="contracts">
    <tr class="custom-table-list-headings">
      <th class="custom-col-width-20">Name</th>
      <th class="custom-col-width-20">Document Category</th>
      <th class="custom-col-width-20">Created By</th>
      <th class="custom-col-width-20">Created At</th>
      <th class="custom-col-width-20 th-last">Action</th>
    </tr>
    @if (!isLoadRecords) {
      @for (workflow of workflowList; track workflow; let index = $index) {
        <tr class="custom-table-list-row-main">
          <td class="custom-col-width-20">
            {{ workflow?.name }}
          </td>
          <td class="custom-col-width-20">{{workflow?.documentType?.name}}</td>
          <td class="custom-col-width-20">
            {{ workflow.userDetails?.name }}
          </td>
          <td class="custom-col-width-20">
            {{ workflow?.created ? (workflow.created | date: 'dd MMM yy, hh:mm a') : ''}}
          </td>
          <td class="custom-col-width-20 d-flex ">
            <ng-container class="justify-content-start">
              <span class="cursor-pointer" data-bs-toggle="tooltip" ngbTooltip="View Workflow"
                [placement]="'top'" appAccessControl allowedRoles="workflow.view">
                <div (click)="viewWorkflow(workflow)" tooltipClass="custom-tooltip"
                  class="btn btn-primary btn-sm me-2 b-btn">
                  <app-common-icon [faIcon]="faEye" [loadingIcon]="viewLoading"></app-common-icon>
                </div>
              </span>
              @if (workflow.status === 'Active' && hasEditAccess(workflow)) {
                <span class="cursor-pointer" data-bs-toggle="tooltip"
                  ngbTooltip="Edit Workflow" [placement]="'top'" appAccessControl
                  allowedRoles="workflow.update">
                  <div (click)="editWorkflow(workflow)" tooltipClass="custom-tooltip"
                    class="btn btn-primary btn-sm me-2 b-btn">
                    <app-common-icon [faIcon]="faEdit" [loadingIcon]="editLoading"></app-common-icon>
                  </div>
                </span>
              }
              @if ((workflow.status === 'Active' && hasEditAccess(workflow)) || commonService.orgLock()) {
                <span class="cursor-pointer" data-bs-toggle="tooltip" ngbTooltip="Deactivate Workflow"
                  [placement]="'top'" appAccessControl allowedRoles="workflow.delete">
                  <div (click)="deleteWorkflow(workflow)" tooltipClass="custom-tooltip"
                    class="btn btn-primary btn-sm me-2 b-btn">
                    <app-common-icon [faIcon]="faTrashCan"></app-common-icon>
                  </div>
                </span>
              }
              @if (workflow.status === 'InActive' && hasEditAccess(workflow)) {
                <span class="cursor-pointer" data-bs-toggle="tooltip" ngbTooltip="Activate Workflow"
                  [placement]="'top'" appAccessControl allowedRoles="workflow.delete">
                  <div (click)="ActivateWorkflow(workflow)" tooltipClass="custom-tooltip"
                    class="btn btn-primary btn-sm me-2 b-btn">
                    <app-common-icon [faIcon]="faCheckCircle"></app-common-icon>
                  </div>
                </span>
              }
            </ng-container>
          </td>
        </tr>
      }
    }

    @if (isLoadRecords) {
      <tr class="custom-table-list-row-main">
        <td class="custom-col-width-100 text-danger d-flex justify-content-center">
          <app-common-icon [loadingIcon]="isLoadRecords"></app-common-icon>
        </td>
      </tr>
    }
    @if (!isLoadRecords && workflowList.length === 0) {
      <tr class="custom-table-list-row-main">
        <td class="custom-col-width-100 text-danger d-flex justify-content-center">
          No Workflows Found!
        </td>
      </tr>
    }
  </table>
  <div class="footer-page-ination">
    <app-paginator [totalCount]="totalWorkflowCount" (selectedPage)="handlePaginationPageChange($event)">
    </app-paginator>
  </div>
</div>

@if (isPanelOpen) {
  @if (isPanelOpen) {
    <div>
      <div class="overlay" [class.show]="isPanelOpen"></div>
      <div class="off-canvas width-1000" [class.show]="isPanelOpen">
        <div class="off-canvas-content" [class.show]="isPanelOpen">
          <app-add-workflow [workflowData]="selectedWorkflow" [mode]="panelMode" [company]="activeCompanyId"
          (closePopup)="closeManagePanel($event)"></app-add-workflow>
        </div>
      </div>
    </div>
  }
}

@if (showSuccessToaster) {
  <app-toast [title]="toasterMessage" (closeToaster)="closeToaster()"></app-toast>
}
@if (showErrorToaster) {
  <app-error-toaster [title]="toasterMessage"
  (closeToaster)="closeToaster()"></app-error-toaster>
}

